import React, { useState, useEffect } from 'react';
import { authService } from '../services/authService';
import Layout from '../components/Layout';
import PasswordChangeModal from '../components/PasswordChangeModal';
import { LOGIN_URL } from '../config';

export default function Performance() {
  const [user, setUser] = useState(null);
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const changePasswordParam = urlParams.get('changePassword');
    
    if (changePasswordParam === 'true') {
      const userStr = sessionStorage.getItem('signalcue_user');
      if (userStr) {
        const userData = JSON.parse(userStr);
        setUser(userData);
        if (userData.must_change_password) {
          setShowPasswordModal(true);
          window.history.replaceState({}, document.title, window.location.pathname);
        } else {
          loadUserData();
        }
      } else {
        loadUserData();
      }
    } else {
      loadUserData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadUserData = async () => {
    try {
      const userData = await authService.getCurrentUser();
      if (!userData) {
        window.location.href = `${LOGIN_URL}/login`;
        return;
      }

      setUser(userData);

      if (userData.must_change_password) {
        setShowPasswordModal(true);
      }
    } catch (error) {
      console.error('Failed to load user:', error);
      window.location.href = `${LOGIN_URL}/login`;
    }
  };

  const handlePasswordChanged = async () => {
    const updatedUserData = await authService.getCurrentUser();
    if (updatedUserData) {
      setUser(updatedUserData);
    }
  };

  if (!user) {
    return null;
  }

  return (
    <Layout user={user}>
      {/* Password Change Modal */}
      {showPasswordModal && (
        <PasswordChangeModal
          user={user}
          onPasswordChanged={handlePasswordChanged}
          onClose={() => setShowPasswordModal(false)}
        />
      )}

      <div className="bg-white rounded-xl shadow-sm p-12 text-center">
        <div className="mb-4">
          <svg className="w-16 h-16 mx-auto text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
        </div>
        <h2 className="text-2xl font-semibold text-gray-900 mb-2">Performance</h2>
        <p className="text-gray-600 mb-4">This feature is coming soon.</p>
        <span className="inline-block bg-gray-100 text-gray-700 px-4 py-2 rounded-lg text-sm font-medium">
          Coming Soon
        </span>
      </div>
    </Layout>
  );
}
